import actions from '@/core/store/ata/actions'
import getters from '@/core/store/ata/getters'
import mutations from '@/core/store/ata/mutations'
import state from '@/core/store/ata/state'
import documento from '@/core/store/ata/documento'

export default {
	actions,
	getters,
	mutations,
	state,
	modules: {
		documento,
	},
}
